// @ts-nocheck
import React, { useState, useRef, useMemo } from "react";
import {
  Button,
  Box,
  Textarea,
  Text,
  Spinner,
  IconButton,
  Icon,
  useColorModeValue,
  theme,
  useMediaQuery,
  Tooltip,
  Input,
  Flex,
  Link,
  FormControl,
  FormLabel,
  ButtonGroup,
  Select,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Alert,
  AlertDescription,
  Center,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverHeader,
  PopoverBody,
  Grid,
  GridItem,
  TabPanels,
  Tabs,
  TabList,
  TabPanel,
  Tab,
  useColorMode,
  Stack,
  VStack,
} from "@chakra-ui/react";
import shortid from "shortid";
import classNames from "classnames";
import { useSession } from "next-auth/react";
import { layerStyle } from "../../theme/names";

import { FilePond, registerPlugin } from "react-filepond";
import "filepond/dist/filepond.min.css";
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";
import { CopyToClipboard } from "react-copy-to-clipboard";
import {
  MdSuperscript,
  MdSubscript,
  MdFormatBold,
  MdFormatItalic,
  MdStrikethroughS,
  MdCode,
  MdFormatUnderlined,
} from "react-icons/md";
import { HiOutlineDocumentAdd } from "react-icons/hi";
import { CgFormatItalic } from "react-icons/cg";
import "emoji-mart/css/emoji-mart.css";
import data from "emoji-mart/data/twitter.json";
import { NimblePicker } from "emoji-mart";
import autosize from "autosize";
import Thread from "../../components/tweets/masonry/thread";
import { TweetContext } from "../../context/tweetContext";
import { continuePost } from "../../controllers/search";
import { saveTweet } from "../../controllers/schedule";
import { colors } from "theme/colors/colors";
import toast from "react-hot-toast";
import { getAccount } from "../../utils/sessionHelper";
import { extractImages } from "../../utils/helpers";
import { ImageThumbnail } from "./image-thumbnail";
import { Suggestions } from "components/suggestions";
import { useSuggestions } from "components/suggestions/useSuggestions";
import { useDebouncedCallback } from "use-debounce";
import { getImageSize, uploadOnS3 } from "../../utils/uploadUtils";
import { useFirebaseUser } from "../../utils/useFirebaseUser";
import { useOnClickOutside, hslToHsla } from "../../utils/helpers";
import { useDropzone } from "react-dropzone";
import * as Bowser from "bowser";
import { FiShare2 } from "react-icons/fi";
import { FaDesktop, FaMobileAlt } from "react-icons/fa";
import { GifBox } from "components/gif-box";
import StringSimilarity from "string-similarity";
import {
  replaceSelectedWithUnicode,
  keepRefreshSelection,
} from "./textToUnicode";
import { ImageEditPopup } from "components/popups/imageEditPopup";
import { Snippets } from "components/snippets";
import { MainContext } from "context/mainContext";
import { radius, textStyle, variant } from "theme/names";
import { color as colorNames } from "theme/names";
import { FiEdit3 } from "react-icons/fi";
import moment from "moment";
import { useWindowWidth } from "@react-hook/window-size";
import { BsLightningChargeFill } from "react-icons/bs";
import { AiGradientSvg } from "components/ai-gradient-svg";
import { ChevronDownIcon, InfoOutlineIcon } from "@chakra-ui/icons";
import { prompts } from "./utils";
import { useChatContext } from "context/chatContext";
import { AiButtonSVGIcon, PollIcon, RemovePollIcon } from "./icons";
import GenerateImage from "./generate-image";
import { createThumbnail, getUserMedias, postMedia } from "controllers/media";
import MediaMasonry, { MediaObject } from "components/media-masonry";
import Loader from "react-spinners/PuffLoader";
import * as analytics from "../../utils/analytics";
import { sanitizeInput } from "../../utils/sanitizationHelpers";
import { FaTrash } from "react-icons/fa";
import PollModal from "./poll-modal";
import { captureException, captureMessage } from "@sentry/nextjs";

registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview);

const BUCKET_NAME = process.env.NEXT_PUBLIC_PROJECT_BUCKET;

const baseStyle = {};

const activeStyle = {
  borderColor: "#2196f3",
  borderWidth: 2,
};

const acceptStyle = {
  borderColor: "#00e676",
};

const rejectStyle = {
  borderColor: "#ff1744",
};

const uploadingFiles = [];

let browser;
if (typeof window !== "undefined")
  browser = Bowser.getParser(window.navigator.userAgent);

export const widthLimitShowPreviewInFullMode = 1300;

const filePondLable = `
  <div class="filepond--icon">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M22 13C21.7348 13 21.4804 13.1054 21.2929 13.2929C21.1054 13.4804 21 13.7348 21 14V18.213C20.9992 18.9519 20.7053 19.6603 20.1828 20.1828C19.6603 20.7053 18.9519 20.9992 18.213 21H5.787C5.04809 20.9992 4.33966 20.7053 3.81717 20.1828C3.29468 19.6603 3.00079 18.9519 3 18.213V14C3 13.7348 2.89464 13.4804 2.70711 13.2929C2.51957 13.1054 2.26522 13 2 13C1.73478 13 1.48043 13.1054 1.29289 13.2929C1.10536 13.4804 1 13.7348 1 14V18.213C1.00132 19.4822 1.50609 20.699 2.40354 21.5965C3.30099 22.4939 4.51782 22.9987 5.787 23H18.213C19.4822 22.9987 20.699 22.4939 21.5965 21.5965C22.4939 20.699 22.9987 19.4822 23 18.213V14C23 13.7348 22.8946 13.4804 22.7071 13.2929C22.5196 13.1054 22.2652 13 22 13Z" fill="#828282"/>
      <path d="M6.707 8.70703L11 4.41403V17C11 17.2652 11.1054 17.5196 11.2929 17.7071C11.4804 17.8947 11.7348 18 12 18C12.2652 18 12.5196 17.8947 12.7071 17.7071C12.8946 17.5196 13 17.2652 13 17V4.41403L17.293 8.70703C17.4816 8.88919 17.7342 8.98998 17.9964 8.9877C18.2586 8.98543 18.5094 8.88026 18.6948 8.69485C18.8802 8.50944 18.9854 8.25863 18.9877 7.99643C18.99 7.73423 18.8892 7.48163 18.707 7.29303L12.707 1.29303C12.5195 1.10556 12.2652 1.00024 12 1.00024C11.7348 1.00024 11.4805 1.10556 11.293 1.29303L5.293 7.29303C5.11085 7.48163 5.01005 7.73423 5.01233 7.99643C5.01461 8.25863 5.11978 8.50944 5.30518 8.69485C5.49059 8.88026 5.7414 8.98543 6.0036 8.9877C6.2658 8.98998 6.5184 8.88919 6.707 8.70703Z" fill="#828282"/>
      </svg>
  </div>
  <div>Click to <span class="filepond--label-action">Upload</span> or drag & drop</div>
`;

// File validation constants
const FILE_TYPE_CONFIG = {
  IMAGE: {
    type: "image",
    maxSize: 5000000,
    minDimension: 4,
    maxDimension: 6000,
    idPrefix: "",
    validationMessage: {
      size: "Images & Gifs cannot be bigger than 5MB",
      dimensions: "Image dimensions must be >= 4x4 and <= 6000x6000",
    },
  },
  GIF: {
    type: "image/gif",
    maxSize: 5000000,
    idPrefix: "gif-",
    validationMessage: {
      size: "GIFs cannot be bigger than 5MB",
    },
  },
  VIDEO: {
    type: "video",
    maxSize: 128000000,
    idPrefix: "vid-",
    validationMessage: {
      size: "Videos cannot be bigger than 128MB",
    },
  },
  PDF: {
    type: "application/pdf",
    maxSize: 128000000,
    idPrefix: "doc-",
    validationMessage: {
      size: "PDFs cannot be bigger than 128MB",
    },
  },
};

const MAX_FILE_SIZE = 128000000;
const MAX_MEDIA_COUNT = 4;
const MAX_GIF_VIDEO_COUNT = 1;

/**
 * Validates a file based on its type, size, and dimensions
 * @param {File} file - The file to validate
 * @returns {Promise<{isValid: boolean, message?: string, fileType?: string}>}
 */
const validateFile = async (file) => {
  // Check if file exists
  if (!file) {
    return { isValid: false, message: "No file provided" };
  }

  // Determine file type
  const isImage = file.type.includes(FILE_TYPE_CONFIG.IMAGE.type) && file.type !== FILE_TYPE_CONFIG.GIF.type;
  const isGif = file.type === FILE_TYPE_CONFIG.GIF.type;
  const isVideo = file.type.includes(FILE_TYPE_CONFIG.VIDEO.type);
  const isPdf = file.type.includes(FILE_TYPE_CONFIG.PDF.type);

  // Check if file type is supported
  if (!isImage && !isGif && !isVideo && !isPdf) {
    return {
      isValid: false,
      message: "Only images, GIFs, videos, and PDFs are supported"
    };
  }

  // Check file size based on type
  if (isImage || isGif) {
    if (file.size > FILE_TYPE_CONFIG.IMAGE.maxSize) {
      return {
        isValid: false,
        message: FILE_TYPE_CONFIG.IMAGE.validationMessage.size
      };
    }

    if (isImage) {
      try {
        const size = await getImageSize(file);
        const { minDimension, maxDimension } = FILE_TYPE_CONFIG.IMAGE;

        if (size.height < minDimension ||
          size.height > maxDimension ||
          size.width < minDimension ||
          size.width > maxDimension) {
          return {
            isValid: false,
            message: FILE_TYPE_CONFIG.IMAGE.validationMessage.dimensions
          };
        }
      } catch (error) {
        captureException(error, {
          tags: {
            location: "validateFile",
            fileType: "image"
          }
        });
        return {
          isValid: false,
          message: "Failed to validate image dimensions"
        };
      }
    }
  } else if (isVideo && file.size > FILE_TYPE_CONFIG.VIDEO.maxSize) {
    return {
      isValid: false,
      message: FILE_TYPE_CONFIG.VIDEO.validationMessage.size
    };
  } else if (isPdf && file.size > FILE_TYPE_CONFIG.PDF.maxSize) {
    return {
      isValid: false,
      message: FILE_TYPE_CONFIG.PDF.validationMessage.size
    };
  } else if (file.size > MAX_FILE_SIZE) {
    return {
      isValid: false,
      message: "Files cannot be bigger than 128MB"
    };
  }

  let fileType = "unknown";
  if (isImage) fileType = "image";
  if (isGif) fileType = "gif";
  if (isVideo) fileType = "video";
  if (isPdf) fileType = "pdf";

  return {
    isValid: true,
    fileType
  };
};

// Add this function after the validateFile function
const getMediaTypesInText = (text: string) => {
  const mediaTypes = {
    hasImage: false,
    hasVideo: false,
    hasGif: false,
    hasDoc: false,
    hasPoll: false
  };

  if (!text) return mediaTypes;

  // Check for images
  const imageMatches = text.match(/\[img:(?!vid-|gif-|doc-).*?\]/g);
  if (imageMatches?.length) mediaTypes.hasImage = true;

  // Check for videos
  const videoMatches = text.match(/\[img:vid-.*?\]/g);
  if (videoMatches?.length) mediaTypes.hasVideo = true;

  // Check for gifs
  const gifMatches = text.match(/\[img:gif-.*?\]/g);
  if (gifMatches?.length) mediaTypes.hasGif = true;

  // Check for documents
  const docMatches = text.match(/\[img:doc-.*?\]/g);
  if (docMatches?.length) mediaTypes.hasDoc = true;

  // Check for polls
  const pollMatches = text.match(/#>poll:.*?#/g);
  if (pollMatches?.length) mediaTypes.hasPoll = true;

  return mediaTypes;
};

const isMediaCompatible = (mediaTypes: any, newMediaType: string) => {
  // If there's no media yet, everything is compatible
  if (!mediaTypes.hasImage && !mediaTypes.hasVideo && !mediaTypes.hasGif && !mediaTypes.hasDoc && !mediaTypes.hasPoll) {
    return true;
  }

  // If there's a poll, no other media is allowed
  if (mediaTypes.hasPoll) {
    return false;
  }

  // If there's a video or document, no other media is allowed
  if (mediaTypes.hasVideo || mediaTypes.hasDoc) {
    return false;
  }

  // If there's an image, only gifs are allowed
  if (mediaTypes.hasImage) {
    return newMediaType === 'gif';
  }

  // If there's a gif, only images are allowed
  if (mediaTypes.hasGif) {
    return newMediaType === 'image';
  }

  return true;
};

// Add this function after the isMediaCompatible function
const getMediaCompatibilityError = (mediaTypes: any, newMediaType?: string) => {
  if (mediaTypes.hasPoll) {
    return "Polls cannot be combined with other media types";
  }
  if (mediaTypes.hasVideo) {
    return "Videos cannot be combined with other media types";
  }
  if (mediaTypes.hasDoc) {
    return "Documents cannot be combined with other media types";
  }
  if (mediaTypes.hasImage && newMediaType !== 'gif') {
    return "Only GIFs can be added to images";
  }
  if (mediaTypes.hasGif && newMediaType !== 'image') {
    return "Only images can be added to GIFs";
  }
  return "";
};

// Add this after getMediaCompatibilityError function
const isMediaTypeDisabled = (mediaTypes: any, mediaType: string) => {
  if (mediaType === 'poll') {
    return mediaTypes.hasImage || mediaTypes.hasGif || mediaTypes.hasVideo || mediaTypes.hasDoc;
  }

  if (mediaType === 'video') {
    return mediaTypes.hasImage || mediaTypes.hasGif || mediaTypes.hasPoll || mediaTypes.hasDoc;
  }

  if (mediaType === 'document') {
    return mediaTypes.hasImage || mediaTypes.hasGif || mediaTypes.hasPoll || mediaTypes.hasVideo;
  }

  if (mediaType === 'gif') {
    return mediaTypes.hasPoll ||
      (mediaTypes.hasVideo && !mediaTypes.hasGif) ||
      (mediaTypes.hasDoc && !mediaTypes.hasGif) ||
      (mediaTypes.hasImage && !mediaTypes.hasGif);
  }

  if (mediaType === 'image') {
    return mediaTypes.hasPoll ||
      (mediaTypes.hasVideo && !mediaTypes.hasImage) ||
      (mediaTypes.hasDoc && !mediaTypes.hasImage) ||
      (mediaTypes.hasGif && !mediaTypes.hasImage);
  }

  return false;
};

export const TweetComposer = React.forwardRef((props: any, ref) => {
  //@ts-ignore
  let {
    id,
    setId,
    createDraft,
    newTweet,
    initText,
    initFiles,
    disableHeader = false,
    isFullMode = false,
    submit = null,
    onUpdate = null,
    disableImage = false,
    isDisabled = false,
    disableThread = false,
    disableRichText = false,
    disableSnippets = false,
    disablePoll = true,
    customSave = undefined,
    mode = "tweet",
    isPostTwitter = true,
    disableAiContinue = false,
    isFocused = false,
    removeTweet = undefined,
    tweet = undefined,
    disableGif = false,
    selectedTweet = undefined,
    height = undefined,
    imageEditor = false,
    image = undefined,
    onNewDraft = () => { },
    forceHeight = "unset",
    disableSuggestion = false,
  } = props;

  const [isSaving, setIsSaving] = React.useState(false);
  const [isSaved, setIsSaved] = React.useState(false);
  const [showEmojiPicker, setShowEmojiPicker] = React.useState(false);
  const [nbChar, setNbChar] = React.useState(0);
  const [tweetError, setTweetError] = React.useState({});
  const [showPDFNotice, setShowPDFNotice] = React.useState(false);

  const [textState, setTextState] = React.useState({
    id: id,
    text: initText ? initText : "",
    typingTimeout: undefined,
    isSaved: false,
    scheduledTime: undefined,
    files: initFiles ? initFiles : [],
    threadTweets: [],
  });
  const { data: session, status } = useSession() ?? {};
  const loading = status === "loading";

  const isMountedRef = React.useRef(false);
  const [isTooSmallForThread] = useMediaQuery("(max-width: 800px)");
  const [shiftRichTextBox] = useMediaQuery("(max-width: 1023px)");
  const tweetContext: any = React.useContext(TweetContext);
  const isAuthenticated = useFirebaseUser();
  const mainContext = React.useContext(MainContext);
  const chatContext: any = useChatContext();
  const screenWidth = useWindowWidth();

  const [isRichTextOpen, setIsRichTextOpen] = React.useState(false);
  const [isSnippetsOpen, setIsSnippetsOpen] = React.useState(false);

  const [isGenerating, setIsGenerating] = React.useState(false);
  const [isSavingImage, setIsSavingImage] = React.useState(false);
  const refTriggerEmoji = React.useRef();
  const refTextArea = React.useRef(null);
  const refData = React.useRef();
  const refId = React.useRef();
  const {
    isSuggestionsOpen,
    setIsSuggestionOpen,
    checkForSuggestions,
    suggestions,
    setSuggestions,
    updateText,
    disableArrowKeys,
    position,
  } = useSuggestions(refTextArea);
  refId.current = id;

  const refPond = React.useRef();
  // const [files, setFiles] = React.useState(initFiles ? initFiles : []);
  const [files, setFiles] = React.useState([]);
  const backgroundColor = useColorModeValue("white", "gray.800");
  const debounced = useDebouncedCallback(checkForSuggestions, 400);

  const [alwaysShowSidebar, setAlwaysShowSidebar] = useState<boolean>(false);
  const [hasInit, setHasInit] = useState<boolean>(false);

  const [isOpenEmoji, setIsOpenEmoji] = React.useState(false);
  const [isGifOpen, setIsGifOpen] = useState<boolean>(false);
  const [isSavingGif, setIsSavingGif] = useState<boolean>(false);
  const [showDesktopPreview, setShowDesktopPreview] = useState<boolean>(false);
  const [selectedImageId, setSelectedImageId] = useState<string>("");
  const refEmoji = React.useRef<any>();
  const suggestionPopupRef = useRef(null);
  const refGif = useRef(null);
  const [medias, setMedias] = useState<MediaObject[]>([]);
  const [hasFetchedMedia, setHasFetchedMedia] = useState<boolean>(false);
  const [selectedMedias, setSelectedMedias] = useState<string[]>([]);
  const [tabIndex, setTabIndex] = useState(0);
  const toastShownRef = useRef(false);
  const uploadingGifOrVideoCountRef = useRef(0);

  // const bgTogglePreview = useColorModeValue("gray.50", "gray.800");
  // const bgTogglePreviewEnabled = useColorModeValue("gray.200", "gray.500");
  const bgGray100_600 = useColorModeValue(
    theme.colors.gray[100],
    theme.colors.gray[600]
  );
  const bgWhite_gray800 = useColorModeValue("white", "gray.800");
  // const color_custom_whiteAlpha = useColorModeValue("#ccd0d5", "whiteAlpha.400");
  // const color_white_gray800 = useColorModeValue("white", "gray.800");
  const {
    isOpen: isOpenImageEdit,
    onClose: onCloseImageEdit,
    onOpen: onOpenImageEdit,
  } = useDisclosure();
  const {
    isOpen: isOpenDocument,
    onClose: onCloseDocumentInternal,
    onOpen: onOpenDocument,
  } = useDisclosure();
  const {
    isOpen: isOpenImageUpload,
    onOpen: onOpenImageUpload,
    onClose: onCloseImageUpload,
  } = useDisclosure();

  const [documentName, setDocumentName] = useState<string>("");

  const nimblePickerTheme = useColorModeValue("light", "dark");
  const aiOptionHeaderColor = useColorModeValue("#0A66C2", "linkedin.300");
  const aiOptionPopoverBg = useColorModeValue("white", "#1E1E1E");
  const aiOptionActionButtonHoverBg = useColorModeValue("#f6f6f6", "#252525");
  const { colorMode } = useColorMode();

  const [pollQuestion, setPollQuestion] = useState("");
  const [pollOptions, setPollOptions] = useState(["", ""]);
  const [pollDuration, setPollDuration] = useState("ONE_DAY");
  const { isOpen: isPollOpen, onOpen: onOpenPoll, onClose: onClosePoll } = useDisclosure();

  const processedFiles = new Set();

  const onFileUpload = async (acceptedFiles) => {
    if (!acceptedFiles.length) return;

    setIsSavingImage(true);
    const file = acceptedFiles[0];

    const validationResult = await validateFile(file);
    if (!validationResult.isValid) {
      toast.error(validationResult.message);
      setIsSavingImage(false);
      toastShownRef.current = false;
      return;
    }

    const { fileType } = validationResult;
    const mediaTypes = getMediaTypesInText(textState.text);

    if (isMediaTypeDisabled(mediaTypes, fileType)) {
      const errorMessage = getMediaCompatibilityError(mediaTypes, fileType);
      toast.error(errorMessage);
      setIsSavingImage(false);
      toastShownRef.current = false;
      return;
    }

    // Generate the fileId here (like in the original code)
    let fileId = "";
    if (fileType === "video") fileId += FILE_TYPE_CONFIG.VIDEO.idPrefix;
    if (fileType === "pdf") fileId += FILE_TYPE_CONFIG.PDF.idPrefix;
    if (fileType === "gif") fileId += FILE_TYPE_CONFIG.GIF.idPrefix;
    fileId += shortid.generate().replace("-", "_");

    const params = {
      Bucket: BUCKET_NAME,
      Key: "userUpload/" + fileId,
      Body: file,
      ACL: "public-read",
    };

    try {
      await uploadOnS3(params);

      // Post media metadata to backend
      if (fileType !== "pdf") {
        const response = await postMedia(session, {
          url: `https://ez4cast.s3.eu-west-1.amazonaws.com/userUpload/${fileId}`,
          type: file.type,
          fileName: fileId,
          size: file.size,
          id: fileId,
        });

        if (response?.success === 0) {
          console.warn("[MEDIA POST FAILED] Backend rejected media:", response.error);
          toast.error("Failed to process media: " + (response.error || "Unknown error"));
          return;
        }

        // Create thumbnail for videos
        if (fileType === "video") {
          await createThumbnail(session, {
            id: fileId,
            isInfluentLeader: true,
          });
        }
      }

      // Only update text state AFTER the file is successfully uploaded and processed
      await pushText("[img:" + fileId + "]");
      if (fileType === "pdf") {
        onOpenDocument();
      }
      onCloseImageUpload();
    } catch (error) {
      toast.error("Upload failed: " + (error.message || "Unknown error"));
    } finally {
      setIsSavingImage(false);
      if (fileType === "gif") setIsSavingGif(false);
      toastShownRef.current = false;
    }
  };
  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject,
  } = useDropzone({
    accept: {
      "image/*": [".jpeg", ".jpg", ".png", ".gif"],
      "video/*": [".mp4", ".avi", ".wmv", ".flv", ".mkv", ".webm"],
      "application/pdf": [".pdf"],
    },
    noClick: true,
    onDropRejected: () => toast.error("Unsupported file format"),
    onDrop: onFileUpload,
  });

  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isDragActive ? activeStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
    }),
    [isDragActive, isDragReject, isDragAccept]
  );

  useOnClickOutside(refEmoji, async () => {
    await new Promise((resolve) => setTimeout(resolve, 200));
    setIsOpenEmoji(false);
  });
  useOnClickOutside(suggestionPopupRef, async () => {
    await new Promise((resolve) => setTimeout(resolve, 200));
    setIsSuggestionOpen(false);
    if (refTextArea?.current?.focus) {
      refTextArea.current.focus();
    }
  });
  useOnClickOutside(refGif, async () => {
    await new Promise((resolve) => setTimeout(resolve, 200));
    setIsGifOpen(false);
  });

  const onCloseDocument = (abort = true) => {
    if (abort) {
      let matches = textState?.text?.match(/(?:\[img:doc-)(.*?)(?=\])]/g, "");
      // console.log('matches:', matches);
      matches.forEach((match) => {
        textState.text = textState?.text?.replace(match, "");
      });
      editText(textState.text);
    }

    onCloseDocumentInternal();
  };

  const handleInit = () => {
    // console.log("FilePond instance has initialised", refPond);
  };

  useOnClickOutside(refGif, async () => {
    await new Promise((resolve) => setTimeout(resolve, 200));
    setIsGifOpen(false);
  });

  const focus = async () => {
    await new Promise((resolve) => setTimeout(resolve, 200));
    // console.log("Tweet Composer focus", refTextArea.current)
    refTextArea?.current?.focus();
  };

  React.useEffect(() => {
    if (!hasInit && isAuthenticated) {
      setAlwaysShowSidebar(getAccount(session)?.alwaysShowSidebar);
    }
  }, [isAuthenticated]);

  React.useEffect(() => {
    // console.log("TweetComposer", isFocused)
    if (isFocused) {
      focus();
    }
  }, [isFocused]);

  React.useEffect(() => {
    autosize(refTextArea.current);
    return () => {
      autosize.destroy(refTextArea.current);
    };
  }, []);

  const forceUpdateAutosize = function () {
    setTimeout(() => {
      autosize.update(refTextArea.current);
    }, 100);
  };

  React.useEffect(() => {
    forceUpdateAutosize();
  }, [
    tweetContext.isOpen,
    tweetContext.isEditAndTweet,
    isGenerating,
    tweetContext.isTweetTextChanged,
  ]);

  React.useImperativeHandle(ref, () => ({
    textState: () => {
      return textState;
    },
    textStateClean: () => {
      return {
        ...textState,
        text: textState.text.replace(/#>poll:.*?#/g, "").trim(),
      };
    },
    setTextState: (state) => {
      // console.log(state)
      updateState(state);
    },
    editText: (text) => {
      editText(text);
    },
    focus: focus,
    resetUploader: (newFiles) => {
      // console.log("resetUploader")
      // console.log("current files: " + JSON.stringify(files))
      // console.log("new files: " + JSON.stringify(newFiles))
      // refPond.current.removeFiles()
      // setFiles(newFiles)
      // setFiles([])
      // destroyPond(refPond.current)
      // let files = refPond.current.getFiles()
      // newFiles.forEach(file => {
      //     console.log("add file: " + file)
      //     refPond.current.addFile(file)
      // })
    },
    simulateInput: () => {
      // console.log("simulateInput")
      var event = new Event("input", { bubbles: true });
      var node = document.getElementById("tweet-area");
      node.dispatchEvent(event);
    },
    // }), [textState])
  }));

  React.useEffect(() => {
    if (!textState?.text?.includes("img:doc-")) setShowPDFNotice(false);
    else if (
      textState?.text?.includes("img:doc-") &&
      textState?.hasAttachedCanvaPDF
    )
      setShowPDFNotice(true);

    if (textState?.text?.length) {
      let text = textState.text;
      // if (!textState.threadTweets || textState.threadTweets.length <= 1) {
      //     let matchs = text.match(/(?:\[img:)(.*?)(?=\])/g)
      //     if (matchs) {
      //         matchs.forEach(match => {
      //             match = match + "]"
      //             text = text.replace(match, "")
      //         })
      //     }
      // }

      setNbChar(text.trimEnd().length);
    } else setNbChar(0);

    // probably causing the cursor bug -> commenting
    // var event = new Event('input', { bubbles: true })
    // var node = document.getElementById('tweet-area')
    // node.dispatchEvent(event)
  }, [textState]);

  // console.log("refId: " + refId.current)
  // console.log("nbChar: " + nbChar)

  // React.useEffect(() => {
  //     console.log("init TweetComposer")
  // }, [])

  // console.log("render TweetComposer " + textState.text)

  React.useEffect(() => {
    // console.log("initText / initFiles changed: " + initText)
    updateState({
      ...textState,
      text: initText,
      files: initFiles,
      // files: initFiles,
    });
    forceUpdateAutosize();
  }, [initText, initFiles]);

  React.useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  React.useEffect(() => {
    if (isOpenImageUpload) return;
    setMedias([]);
    setHasFetchedMedia(false);
  }, [isOpenImageUpload]);

  // React.useEffect(() => {
  //   // force refresh when id change (for thread to display nicely)
  //   editText(textState.text);
  //   setTweetError({});
  // }, [id]);

  const fetchData = async () => {
    const response = await getUserMedias(session, { isInfluentLeader: true });
    if (response?.success) {
      setMedias(response?.data);
      setHasFetchedMedia(true);
    }
  };

  const handleKeyDown = (event) => {
    disableArrowKeys(event);
    // console.log(event.key)
    // console.log(event.ctrlKey)
    if (event.key === "Enter" && (event.ctrlKey || event.metaKey)) {
      console.log("submit");
      submit && submit();
    } else if (event.key === "x" && (event.ctrlKey || event.ctrlKey)) {
      console.log("hide");
      removeTweet && removeTweet(tweet);
    }
  };

  const updateState = (newState) => {
    // console.log("updateState " + JSON.stringify(newState))
    setTextState({
      ...newState,
      threadTweets: newState?.text ? [newState.text] : [],
    });
    refData.current = newState;
  };

  const pushText = async (text) => {
    textState.text = (textState.text ?? "") + text;
    editText(textState.text);
    tweetContext.setIsTweetTextChanged(true);
  };

  const editText = async (value: string, updatedFiles = null) => {
    // console.log("editText tweet " + refId.current + " - value: " + value);

    let sanitizedValue = sanitizeInput(value);

    // console.log(sanitizedValue, "value sanitized");

    // console.log("editText id: " + refId.current + " files: " + JSON.stringify(updatedFiles))
    setIsSaving(true);
    // setText(e.target.value)

    if (refData.current.typingTimeout) {
      clearTimeout(refData.current.typingTimeout);
    }

    let newState = {
      ...refData.current,
      id: refId.current,
    };
    // console.log(newState)

    if (sanitizedValue || sanitizedValue === "") {
      if (!sanitizedValue.includes("[img:")) {
        let imagesOnText = textState?.text?.match(/(?:\[img:)(.*?)(?=\])]/g);
        sanitizedValue += imagesOnText ? imagesOnText.join("") : "";
      }
      if (!sanitizedValue.includes("#>poll:")) {
        let pollOnText = textState?.text?.match(/#>poll:.*?#/g);
        sanitizedValue += pollOnText ? pollOnText.join("") : "";
      }
      // let tweets = value.split("\n\n\n")
      // console.log(tweets)
      newState.threadTweets = [sanitizedValue];
      newState.text = sanitizedValue;

      let images = extractImages(sanitizedValue);
      newState.files = images;
      if (selectedMedias !== images) {
        setSelectedMedias(images);
      }
    }
    // if (updatedFiles)
    //     newState.files = updatedFiles

    if (createDraft || customSave) {
      newState.typingTimeout = setTimeout(async () => {
        if (isMountedRef.current) {
          checkError(sanitizedValue);
          const dataToSave: any = { text: sanitizedValue };
          console.log("saveTweet");
          let hasSaved = await saveTweet(
            session,
            refId.current,
            dataToSave,
            createDraft,
            customSave
          );
          if (hasSaved) setIsSaving(false);
        }
      }, 400);
      // }, 0);
    } else {
      newState.typingTimeout = setTimeout(async () => {
        if (isMountedRef.current) {
          checkError(sanitizedValue);
        }
      }, 400);
    }

    // console.log(newState)
    updateState(newState);
    onUpdate && onUpdate(newState);
  };

  const checkError = (value: string) => {
    console.log("checkError:", value);

    let newError = {};

    if (!value?.match) return;

    let countMention = (value.match(/@/g) || []).length;
    if (countMention >= 1) {
      if (mode !== "tweet") {
        newError = {
          text: "Mentions are only supported in Linkedin posts",
          type: "error",
        };
      } else if (getAccount(session)?.idLinkedin)
        newError = {
          text: "To mention someone, use the username shown in the url when you visit his/her profile",
          type: "info",
        };
      else
        newError = {
          text: (
            <Text textStyle={textStyle["body.medium.light"]} as="span">
              You need to download and setup the{" "}
              <Link textDecoration="underline" href="/connect">
                Taplio Chrome Extension
              </Link>{" "}
              to use mentions
            </Text>
          ),
          type: "error",
        };
    } else if (
      value?.includes("img:doc-") &&
      (!getAccount(session)?.idLinkedin || !getAccount(session)?.accessToken)
    ) {
      newError = {
        text: (
          <Text textStyle={textStyle["body.medium.light"]} as="span">
            You need to download and setup the{" "}
            <Link textDecoration="underline" href="/connect">
              Taplio Chrome Extension
            </Link>{" "}
            to post carousels
          </Text>
        ),
        type: "error",
      };
    } else if (
      tweetContext?.selectedCompany?.id &&
      (!getAccount(session)?.idLinkedin || !getAccount(session)?.accessToken) &&
      mode === "tweet"
    ) {
      newError = {
        text: (
          <Text textStyle={textStyle["body.medium.light"]} as="span">
            You need to download and setup the{" "}
            <Link textDecoration="underline" href="/connect">
              Taplio Chrome Extension
            </Link>{" "}
            to post with company pages
          </Text>
        ),
        type: "error",
      };
    }

    setTweetError(newError);
  };

  const handleSelect = (handle: string) => {
    updateText({ currentText: textState.text, handle }, (updatedText) => {
      editText(updatedText);
    });
  };

  const handleImageClick = (id: string) => {
    const isNotImage = id.includes("vid-") || id.includes("gif-");
    if (isNotImage) {
      setSelectedImageId("");
      return;
    }

    setSelectedImageId(id);
    onOpenImageEdit();
  };

  const handleUseMediaSelection = () => {
    if (selectedMedias.length === 0) {
      toast.error("Please select at least one media");
      return;
    }

    const mediaTypes = getMediaTypesInText(textState.text);
    const newMediaType = selectedMedias.some(media => media.includes('gif-')) ? 'gif' : 'image';

    if (isMediaTypeDisabled(mediaTypes, newMediaType)) {
      const errorMessage = getMediaCompatibilityError(mediaTypes, newMediaType);
      toast.error(errorMessage);
      return;
    }

    tweetContext.setFiles(selectedMedias);
    selectedMedias.forEach((media) => {
      textState.text += "[img:" + media + "]";
      editText(textState.text);
    });
    onCloseImageUpload();
  };

  const getSimilarityWarning = () => {
    if (
      !selectedTweet?.full_text ||
      !textState?.text ||
      selectedTweet?.user?.id == getAccount(session)?.idLinkedin ||
      selectedTweet?.idAccount == getAccount(session)?.idAccount ||
      selectedTweet?.idUser == getAccount(session)?.id ||
      selectedTweet?.user?.username == getAccount(session)?.username ||
      selectedTweet?.user?.username?.includes(getAccount(session)?.username) ||
      getAccount(session)?.username?.includes(selectedTweet?.user?.username) ||
      selectedTweet?.user?.name?.includes(getAccount(session)?.name) ||
      getAccount(session)?.name?.includes(selectedTweet?.user?.name)
    )
      return;

    let similarity = StringSimilarity.compareTwoStrings(
      selectedTweet?.full_text,
      textState.text
    );
    // console.log("similarity score: " + similarity)

    let message = "";
    let color = "gray";
    let status = "";

    if (similarity > 0.99) {
      message = "⚠️ Too similar";
      color = "red.500";
      status = "error";
    } else if (similarity > 0.9) {
      message = "Keep going";
      color = "orange.600";
      status = "warning";
    } else if (similarity > 0.85) {
      message = "Almost there";
      color = "orange.400";
      status = "warning";
    } else {
      message = "All good";
      color = "green.600";
      status = "success";
    }

    return (
      <Flex justifyContent="flex-end" color={color} fontWeight="600">
        <Tooltip label="Your post is very similar to the original post. Please give it your unique touch by changing or adding more content.">
          <Alert status={status}>
            <AlertDescription>{message}</AlertDescription>
          </Alert>
        </Tooltip>
      </Flex>
    );
  };

  const renderNewDraftButton = () => {
    return (
      <Button
        variant={isFullMode ? "secondary" : "tertiary"}
        fontWeight="400"
        onClick={async () => {
          newTweet({ text: "" });
          setShowPDFNotice(false);
          onNewDraft();
        }}
      >
        <Icon viewBox="0 0 14 14" mr={2}>
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.5 7C13.5 7.4375 13.1562 7.75 12.75 7.75H7.75V12.75C7.75 13.1875 7.40625 13.5312 7 13.5312C6.5625 13.5312 6.25 13.1875 6.25 12.75V7.75H1.25C0.8125 7.75 0.5 7.4375 0.5 7.03125C0.5 6.59375 0.8125 6.25 1.25 6.25H6.25V1.25C6.25 0.84375 6.5625 0.53125 7 0.53125C7.40625 0.53125 7.75 0.84375 7.75 1.25V6.25H12.75C13.1562 6.25 13.5 6.59375 13.5 7Z"
              fill="currentColor"
            />
          </svg>
        </Icon>
        New draft
      </Button>
    );
  };

  const renderRichTextOptions = (props = {}) => {
    let { mb = 2 } = props;
    return (
      <Box
        display="flex"
        alignItems="center"
        justifyContent="flex-end"
        mb={mb}
        color={"gray.500"}
      >
        <IconButton
          aria-label="make text bold"
          zIndex="9"
          // variant="unstyled"
          variant="ghost"
          size="sm"
          icon={<Icon as={MdFormatBold} color="gray.500" fontSize="16px" />}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            editText(
              replaceSelectedWithUnicode(refTextArea.current, "sansBold")
            );
          }}
        />
        <IconButton
          aria-label="make text italic"
          zIndex="9"
          // variant="unstyled"
          variant="ghost"
          size="sm"
          icon={<CgFormatItalic color="gray.500" fontSize="16px" />}
          onClick={(e) => {
            //sansItalic
            e.preventDefault();
            e.stopPropagation();
            editText(
              replaceSelectedWithUnicode(refTextArea.current, "sansItalic")
            );
          }}
        />
        <IconButton
          aria-label="make text italic bold"
          zIndex="9"
          // variant="unstyled"
          variant="ghost"
          size="sm"
          icon={<MdFormatItalic color="gray.500" fontSize="16px" />}
          onClick={(e) => {
            //sansBoldItalic
            e.preventDefault();
            e.stopPropagation();
            editText(
              replaceSelectedWithUnicode(refTextArea.current, "sansBoldItalic")
            );
          }}
        />
        <IconButton
          aria-label="make text underline"
          zIndex="9"
          // variant="unstyled"
          variant="ghost"
          size="sm"
          icon={<MdFormatUnderlined color="gray.500" fontSize="16px" />}
          onClick={(e) => {
            // "", {append: "͟",}
            e.preventDefault();
            e.stopPropagation();
            editText(
              replaceSelectedWithUnicode(refTextArea.current, "", {
                append: "\u035f",
              })
            );
          }}
        />
        <IconButton
          aria-label="make text strike through"
          zIndex="9"
          // variant="unstyled"
          variant="ghost"
          size="sm"
          icon={<MdStrikethroughS color="gray.500" fontSize="16px" />}
          onClick={(e) => {
            //"", { append: "̶",}
            e.preventDefault();
            e.stopPropagation();
            editText(
              replaceSelectedWithUnicode(refTextArea.current, "", {
                append: "\u0336",
              })
            );
          }}
        />
        <IconButton
          aria-label="make text superscript"
          zIndex="9"
          // variant="unstyled"
          variant="ghost"
          size="sm"
          icon={<MdSuperscript color="gray.500" fontSize="16px" />}
          onClick={(e) => {
            //superscript
            e.preventDefault();
            e.stopPropagation();
            editText(
              replaceSelectedWithUnicode(refTextArea.current, "superscript")
            );
          }}
        />
        <IconButton
          aria-label="make text subscript"
          zIndex="9"
          // variant="unstyled"
          variant="ghost"
          size="sm"
          icon={<MdSubscript color="gray.500" fontSize="16px" />}
          onClick={(e) => {
            //subscript
            e.preventDefault();
            e.stopPropagation();
            editText(
              replaceSelectedWithUnicode(refTextArea.current, "subscript")
            );
          }}
        />
        <IconButton
          aria-label="make text monospace"
          zIndex="9"
          // variant="unstyled"
          variant="ghost"
          size="sm"
          icon={<MdCode color="#1E1E1E" fontSize="16px" />}
          onClick={(e) => {
            //monospace
            e.preventDefault();
            e.stopPropagation();
            editText(
              replaceSelectedWithUnicode(refTextArea.current, "monospace")
            );
          }}
        />
        <Select
          placeholder="Font"
          variant="flushed"
          size="sm"
          width={"100px"}
          display="inline-block"
          border="0px"
          textAlign="center"
          onChange={(e) => {
            editText(
              replaceSelectedWithUnicode(refTextArea.current, e.target.value)
            );
          }}
        >
          <option value="normal">Normal Text</option>
          <option value="fullwidth">Fullwidth Text</option>
          <option value="fraktur">Fraktur</option>
          <option value="boldFraktur">Fraktur Bold</option>
          <option value="doubleStruck">Double Struck</option>
          <option value="script">Cursive Script</option>
          <option value="circled">Circled</option>
          <option value="squared">Squared</option>
          <option value="squaredNegative">Squared Inverse</option>
          <option value="inverted">Inverted</option>
          <option value="mirrored">Mirrored</option>
        </Select>
      </Box>
    );
  };

  const handleSendPrompt = async (prompt: any) => {
    if (tweetContext?.refComposer?.current?.textState()?.text?.length < 2) {
      toast.error("Please write a post first");
      return;
    }
    analytics.log("ai_post_improved", {
      improvementType: prompt.title,
    });

    prompt.systemPrompt =
      (prompt?.systemPrompt || "") +
    `\n- write and generate the user's post in ${getAccount(session)?.languagePreferred || "English"
    }. DO NOT USE ANY OTHER LANGUAGE. ONLY ${getAccount(session)?.languagePreferred || "English"
      }.`;

    await chatContext?.chatAssistRef?.current?.setMessages([]);
    chatContext?.onOpen();
    chatContext?.chatAssistRef?.current?.sendMessage(
      prompt?.userPrompt,
      prompt?.systemPrompt
    );
  };

  const handleAddPollOption = () => {
    if (pollOptions.length < 4) {
      setPollOptions([...pollOptions, ""]);
    }
  };

  const handlePollOptionChange = (index, value) => {
    const newOptions = [...pollOptions];
    newOptions[index] = value;
    setPollOptions(newOptions);
  };

  const handleRemovePollOption = (index) => {
    if (pollOptions.length > 2) {
      const newOptions = pollOptions.filter((_, i) => i !== index);
      setPollOptions(newOptions);
    }
  };

  const handleSavePoll = () => {
    const pollData = {
      question: pollQuestion,
      options: pollOptions.filter(opt => opt.trim() !== ""),
      duration: pollDuration
    };

    const cleanedText = textState.text.replace(/#>poll:.*?#/g, '').trim();

    const pollText = `#>poll:${JSON.stringify(pollData)}#`;
    editText(cleanedText + " " + pollText);
    onClosePoll();
    setPollQuestion("");
    setPollOptions(["", ""]);
    setPollDuration("ONE_DAY");
  };

  const handleRemovePoll = () => {
    const cleanedText = textState.text.replace(/#>poll:.*?#/g, '').trim();
    const newState = {
      ...textState,
      text: cleanedText,
      threadTweets: [cleanedText]
    };
    updateState(newState);
    onUpdate && onUpdate(newState);
    setPollQuestion("");
    setPollOptions(["", ""]);
    setPollDuration("ONE_DAY");
  };

  const renderEditOptions = (align = "flex-end") => {
    const isStarterPlan = getAccount(session)?.subscription?.plan === "start";
    const mediaTypes = getMediaTypesInText(textState.text);

    const getMediaTooltip = (type: string) => {
      return getMediaCompatibilityError(mediaTypes, type) || "";
    };

    return (
      <Box
        position="relative"
        mt={1}
        display="flex"
        justifyContent={align}
      >
        {!disableAiContinue && (
          <Popover>
            <Tooltip
              placement="right"
              hasArrow
              label={
                isStarterPlan ?
                  "Upgrade to Standard or Pro to use AI features" :
                  "Use AI to improve or continue your post."
              }
            >
              <Box display="inline-block">
                <PopoverTrigger>
                  <Button
                    isDisabled={isStarterPlan}
                    size="sm"
                    variant="action"
                    minW="fit-content"
                    px="2"
                    leftIcon={
                      <AiButtonSVGIcon style={{ marginRight: "-12px" }} />
                    }
                    rightIcon={<ChevronDownIcon />}
                  />
                </PopoverTrigger>
              </Box>
            </Tooltip>
            <PopoverContent
              fontSize="sm"
              background={aiOptionPopoverBg}
              width="min-content"
            >
              <PopoverHeader color={aiOptionHeaderColor} border="none" mt="1">
                <InfoOutlineIcon
                  style={{ marginRight: "5px", marginTop: "-2px" }}
                />{" "}
                Improve your post with AI
              </PopoverHeader>
              <PopoverBody>
                <Grid templateColumns="repeat(2, 1fr)" gap="1">
                  {prompts.map(({ icon: Icon, ...prompt }, index) => (
                    <GridItem key={index}>
                      <Button
                        leftIcon={<Icon />}
                        size="sm"
                        w="100%"
                        justifyContent="left"
                        fontWeight="medium"
                        bg="transparent"
                        _hover={{ bg: aiOptionActionButtonHoverBg }}
                        onClick={() => handleSendPrompt(prompt)}
                      >
                        {prompt.title}
                      </Button>
                    </GridItem>
                  ))}
                </Grid>
              </PopoverBody>
            </PopoverContent>
          </Popover>
        )}
        {!disablePoll && (
          <>
            {textState.text.includes('#>poll:') ? (
              <Tooltip hasArrow label="Remove poll">
                <IconButton
                  aria-label="remove poll"
                  zIndex="9"
                  variant="action"
                  size="composer"
                  icon={<RemovePollIcon />}
                  onClick={handleRemovePoll}
                />
              </Tooltip>
            ) : (
                <Tooltip hasArrow label={getMediaTooltip('poll') || "Add poll"}>
                <IconButton
                  aria-label="add poll"
                  zIndex="9"
                  variant="action"
                  size="composer"
                    isDisabled={isSavingImage || isSavingGif || isMediaTypeDisabled(mediaTypes, 'poll')}
                  icon={<PollIcon />}
                  onClick={onOpenPoll}
                />
              </Tooltip>
            )}
          </>
        )}
        {!disableSnippets && (
          <Tooltip hasArrow label="Open snippets">
            <IconButton
              aria-label="open snippets"
              zIndex="9"
              variant="action"
              size="composer"
              icon={
                <Icon viewBox="0 0 16 16">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2 14.5H9C9.25 14.5 9.5 14.2812 9.5 14V12H11V14C11 15.125 10.0938 16 9 16H2C0.875 16 0 15.125 0 14V7C0 5.90625 0.875 5 2 5H4V6.5H2C1.71875 6.5 1.5 6.75 1.5 7V14C1.5 14.2812 1.71875 14.5 2 14.5ZM5 2C5 0.90625 5.875 0 7 0H14C15.0938 0 16 0.90625 16 2V9C16 10.125 15.0938 11 14 11H7C5.875 11 5 10.125 5 9V2ZM7 9.5H14C14.25 9.5 14.5 9.28125 14.5 9V2C14.5 1.75 14.25 1.5 14 1.5H7C6.71875 1.5 6.5 1.75 6.5 2V9C6.5 9.28125 6.71875 9.5 7 9.5Z"
                      fill="currentColor"
                    />
                  </svg>
                </Icon>
              }
              onClick={() => {
                setIsSnippetsOpen(!isSnippetsOpen);
              }}
            />
          </Tooltip>
        )}
        {isSnippetsOpen && (
          <Snippets
            isSnippetsOpen={isSnippetsOpen}
            setIsSnippetsOpen={setIsSnippetsOpen}
            pushText={pushText}
            isFullMode={isFullMode}
          />
        )}
        {!disableRichText && (
          <Tooltip hasArrow label="Add rich text">
            <IconButton
              aria-label="add rich text"
              zIndex="9"
              variant="action"
              size="composer"
              size="sm"
              icon={
                <Icon viewBox="0 0 14 14">
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M14 0.75V3.25C14 3.6875 13.6562 4 13.25 4C12.8125 4 12.5 3.6875 12.5 3.25V1.5H7.75V12.5H9.25C9.65625 12.5 10 12.8438 10 13.25C10 13.6875 9.65625 14 9.25 14H4.75C4.3125 14 4 13.6875 4 13.25C4 12.8438 4.3125 12.5 4.75 12.5H6.25V1.5H1.5V3.25C1.5 3.6875 1.15625 4 0.75 4C0.3125 4 0 3.6875 0 3.25V0.75C0 0.34375 0.3125 0 0.75 0H13.25C13.6562 0 14 0.34375 14 0.75Z"
                      fill="currentColor"
                    />
                  </svg>
                </Icon>
              }
              onClick={() => {
                keepRefreshSelection(refTextArea.current);
                setIsRichTextOpen(!isRichTextOpen);
              }}
            />
          </Tooltip>
        )}
        {!disableImage && (
          <>
            <Tooltip hasArrow label={getMediaTooltip('image') || "Add image / video / pdf (carousel)"}>
              <IconButton
                aria-label="add image/pdf (carousel)"
                isLoading={isSavingImage}
                isDisabled={isSavingImage || isSavingGif || isMediaTypeDisabled(mediaTypes, 'image')}
                variant="action"
                size="composer"
                zIndex="9"
                icon={<HiOutlineDocumentAdd size={18} />}
                onClick={() => {
                  setTabIndex(0);
                  setSelectedMedias([]);
                  onOpenImageUpload();
                }}
              />
            </Tooltip>
          </>
        )}

        <Tooltip hasArrow label="Add emoji">
          <IconButton
            ref={refTriggerEmoji}
            aria-label="add emoji"
            zIndex="9"
            variant="action"
            size="composer"
            size="sm"
            icon={
              <Icon viewBox="0 0 16 16">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8 11C9.15625 11 9.96875 10.4688 10.4375 9.96875C10.7188 9.65625 11.1875 9.625 11.5 9.90625C11.8125 10.1875 11.8125 10.6562 11.5312 10.9688C10.8438 11.7188 9.65625 12.5 8 12.5C6.3125 12.5 5.125 11.7188 4.4375 10.9688C4.15625 10.6562 4.15625 10.1875 4.46875 9.90625C4.78125 9.625 5.25 9.65625 5.53125 9.96875C6 10.4688 6.8125 11 8 11ZM6.5 6.5C6.5 7.0625 6.0625 7.5 5.5 7.5C4.9375 7.5 4.5 7.0625 4.5 6.5C4.5 5.96875 4.9375 5.5 5.5 5.5C6.0625 5.5 6.5 5.96875 6.5 6.5ZM9.5 6.5C9.5 5.96875 9.9375 5.5 10.5 5.5C11.0625 5.5 11.5 5.96875 11.5 6.5C11.5 7.0625 11.0625 7.5 10.5 7.5C9.9375 7.5 9.5 7.0625 9.5 6.5ZM16 8C16 12.4375 12.4062 16 8 16C3.5625 16 0 12.4375 0 8C0 3.59375 3.5625 0 8 0C12.4062 0 16 3.59375 16 8ZM8 1.5C4.40625 1.5 1.5 4.4375 1.5 8C1.5 11.5938 4.40625 14.5 8 14.5C11.5625 14.5 14.5 11.5938 14.5 8C14.5 4.4375 11.5625 1.5 8 1.5Z"
                    fill="currentColor"
                  />
                </svg>
              </Icon>
            }
            onClick={() => {
              setIsOpenEmoji(!isOpenEmoji);
            }}
          />
        </Tooltip>

        {isOpenEmoji && (
          <Box
            position="absolute"
            right={isFullMode ? "-75px" : "0px"}
            top={isFullMode ? "-440px" : "40px"}
            w="340px"
            ref={refEmoji}
            zIndex="12"
            layerStyle={layerStyle["bg.border.rounded"]}
          >
            <NimblePicker
              theme={nimblePickerTheme}
              set="twitter"
              data={data}
              sheetSize={64}
              autoFocus={true}
              // style={{ position: 'absolute', top: '60px', right: '-10px', zIndex: "12", display: (showEmojiPicker ? "block" : "none") }}
              // style={{ position: 'fixed', top: emojiPosition.top + "px", left: (emojiPosition.left - 100) + "px", zIndex: "12" }}
              // style={{ position: 'absolute', top: "30px", right: "0px", zIndex: "12" }}
              style={{ zIndex: "12" }}
              onSelect={(e) => {
                // console.log(e)

                const emoji: string = e.native;

                if (document.execCommand) {
                  // document.execCommand is absolute but it //add support for undo redo and insert emoji at carrot position
                  if (refTextArea?.current?.focus) refTextArea.current.focus();
                  var event = new Event("input");
                  document.execCommand("insertText", false, emoji);
                  return;
                } else {
                  let newText = textState.text + emoji;
                  editText(newText);
                }
              }}
            />
          </Box>
        )}
        {!disableGif && (
          <>
            <Tooltip hasArrow label={getMediaTooltip('gif') || "Add gif"}>
              <IconButton
                aria-label="add gif"
                zIndex="10"
                variant="action"
                size="composer"
                isDisabled={isSavingGif || isSavingImage || isMediaTypeDisabled(mediaTypes, 'gif')}
                isLoading={isSavingGif}
                icon={
                  <Icon viewBox="0 0 18 14">
                    <svg
                      width="18"
                      height="14"
                      viewBox="0 0 18 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M16 0H2C0.875 0 0 0.90625 0 2V12C0 13.125 0.875 14 2 14H16C17.0938 14 18 13.125 18 12V2C18 0.90625 17.0938 0 16 0ZM16.5 12C16.5 12.2812 16.25 12.5 16 12.5H2C1.71875 12.5 1.5 12.2812 1.5 12V2C1.5 1.75 1.71875 1.5 2 1.5H16C16.25 1.5 16.5 1.75 16.5 2V12ZM14.5 4.125H11.75C11.375 4.125 11.125 4.40625 11.125 4.75V9.25C11.125 9.625 11.375 9.875 11.75 9.875C12.0938 9.875 12.375 9.625 12.375 9.25V7.625H14C14.3438 7.625 14.625 7.375 14.625 7C14.625 6.65625 14.3438 6.375 14 6.375H12.375V5.375H14.5C14.8438 5.375 15.125 5.125 15.125 4.75C15.125 4.40625 14.8438 4.125 14.5 4.125ZM9.5 4.125C9.125 4.125 8.875 4.40625 8.875 4.75V9.25C8.875 9.625 9.125 9.875 9.5 9.875C9.84375 9.875 10.125 9.625 10.125 9.25V4.75C10.125 4.40625 9.84375 4.125 9.5 4.125ZM7.5 6.625H5.6875C5.34375 6.625 5.0625 6.90625 5.0625 7.25C5.0625 7.625 5.34375 7.875 5.6875 7.875H6.875V8.3125C6.21875 8.78125 5.125 8.71875 4.59375 8.15625C4.28125 7.84375 4.125 7.4375 4.125 7C4.125 6.59375 4.28125 6.1875 4.59375 5.875C5.1875 5.25 6.21875 5.25 6.84375 5.875C7.09375 6.125 7.5 6.125 7.71875 5.875C7.96875 5.625 7.96875 5.21875 7.71875 4.96875C6.65625 3.90625 4.78125 3.90625 3.6875 4.96875C3.15625 5.53125 2.875 6.25 2.875 7C2.875 7.78125 3.15625 8.5 3.6875 9.0625C4.25 9.59375 5 9.875 5.8125 9.875C6.625 9.875 7.375 9.59375 7.9375 9.0625C8.03125 8.9375 8.125 8.78125 8.125 8.59375V7.25C8.125 6.90625 7.84375 6.625 7.5 6.625Z"
                        fill="currentColor"
                      />
                    </svg>
                  </Icon>
                }
                onClick={() => {
                  setIsGifOpen(!isGifOpen);
                }}
              />
            </Tooltip>
            {isGifOpen && (
              <Box
                position="absolute"
                right={isFullMode ? "-75px" : "0px"}
                top={isFullMode ? "-400px" : "40px"}
                p="2"
                // borderRadius={radius.lg}
                // border="1px"
                // borderColor={color_custom_whiteAlpha}
                // background={color_white_gray800}
                layerStyle={layerStyle["bg.border.rounded"]}
                ref={refGif}
                zIndex="12"
              >
                <GifBox
                  onSelect={async (item) => {
                    try {
                      onOpenImageUpload(); //refPond?.current is always undefined since FilePond is moved into the modal, open the modal first to set the value of refPond.current before proceeding further.
                      setIsGifOpen(false);
                      // setIsSavingGif(true); //since modal takes over this...
                      const gifUrl =
                        item?.images?.original?.size &&
                          item?.images?.original?.size > 5000000 &&
                          item?.images?.downsized?.url
                          ? item?.images?.downsized?.url
                          : item.images.original.url; //if gif is more than 5MB fetch the downsized one.
                      const res = await fetch(gifUrl);
                      const blob = await res.blob();
                      const gifFile = new File([blob], item.title, {
                        type: blob.type,
                      });
                      if (refPond?.current?.addFile) {
                        refPond.current.addFile(gifFile);
                      }
                    } catch (e) {
                      setIsSavingGif(false);
                      onCloseImageUpload(); //cleanup for opening the modal if something goes wrong with fetching the gif.
                    }
                  }}
                />
              </Box>
            )}
          </>
        )}
      </Box>
    );
  };

  const renderTextArea = () => {
    return (
      <Textarea
        {...dragProps}
        // layerStyle="border"
        {...{
          // from textArea theme which doesn't seem to get applied
          borderRadius: radius.lg, // not being applied. to be investigated
          border: isFullMode ? "none" : "1px solid",
          borderColor: colorNames.border.lightMode.light,
          // color: "text.lightMode.standard",
          // textStyle: "body.medium.standard",
          _hover: {
            borderColor: isFullMode
              ? "none"
              : colorNames.border.lightMode.hover,
          },
          _dark: {
            borderColor: "border.darkMode.light",
            color: "text.darkMode.standard",
            _hover: {
              borderColor: colorNames.border.darkMode.hover,
            },
          },
        }}
        variant={isFullMode ? "unstyled" : "taplio"}
        textStyle={"body.medium.standard"}
        fontSize="14px"
        ref={refTextArea}
        transition="height none"
        id="tweet-area"
        value={textWithoutImages}
        maxH={
          isThreadReady && browser?.getBrowserName()?.includes("Safari")
            ? "calc(100vh - 300px)"
            : "calc(100vh - 250px)"
        }
        dir={getAccount(session)?.isRtl ? "rtl" : "ltr"}
        //@ts-ignore
        // ref={firstField}
        onKeyDown={handleKeyDown}
        onKeyUp={(e) => {
          if (e.keyCode === 27) {
            setIsSuggestionOpen(false);
            setSuggestions([]);
          }
        }}
        onChange={(e) => {
          if (!disableSuggestion) {
            debounced(e);
          }
          editText(e.target.value);
        }}
        h={height ?? (isFullMode ? "100% !important" : "200px")}
        w="100%"
        resize={"vertical"}
        isDisabled={isDisabled || !isAuthenticated}
        // _focus={{boxShadow: 'none'}}
        // border="none"
        placeholder={"Write here..."}
        onPaste={(e) => {
          // console.log("paste")
          // console.log(e)
          if (e?.clipboardData?.files?.length > 0) {
            e.preventDefault();
            onFileUpload(e.clipboardData.files);
          }
        }}
        // fontFamily="'Source Sans Pro', Helvetica, sans-serif, serif"
        // fontSize="16"
        colorScheme={"primaryChakraColorScheme"}
      />
    );
  };

  const suggestionBoxWidth = 300;
  const textAreaWidth = refTextArea?.current?.clientWidth ?? 0;

  const suggestionsUI = isSuggestionsOpen && suggestions.length > 0 && (
    <Box
      position="absolute"
      zIndex="popover"
      maxH="44"
      backgroundColor={backgroundColor}
      overflow="auto"
      border="1px"
      boxShadow="md"
      width="300px"
      left={
        (position.left + suggestionBoxWidth > textAreaWidth
          ? textAreaWidth - suggestionBoxWidth
          : position.left) + "px"
      }
      borderColor="inherit"
      padding="1"
      top={position.top + 24 + "px"}
      tabIndex={1}
      ref={suggestionPopupRef}
    >
      <Suggestions suggestions={suggestions} onSelect={handleSelect} />
    </Box>
  );

  const saveDocumentName = () => {
    if (documentName?.includes("-")) {
      toast.error("Document name cannot contain '-'");
      return;
    }

    if (!documentName?.length) {
      toast.error("Document name cannot be empty");
      return;
    }

    let matches = textState?.text?.match(/(?:\[img:doc-)(.*?)(?=\])]/g, "");

    if (matches?.length > 1) {
      toast.error("A Linkedin post can't have 2 carousels linked");
      matches.forEach((match) => {
        textState.text = textState?.text?.replace(match, "");
      });
    } else {
      // console.log('matches:', matches)
      matches.forEach((match) => {
        let splits = match.split("-");
        let idWithName = splits[0] + "-" + documentName + "-" + splits[1];
        textState.text = textState?.text?.replace(match, idWithName);
      });
    }

    // console.log('textState text:', textState?.text)
    // updateState(textState)
    editText(textState.text);
    onCloseDocument(false);
  };

  // console.log("browser: " + browser?.getBrowserName())
  // let isThreadReady = !isTooSmallForThread && textState?.threadTweets?.length > 1 && tweetContext.isOpen && mode !== "engage"

  const isThreadReady =
    ((!isTooSmallForThread && textState?.text?.length > 5) ||
      (isFullMode && screenWidth > widthLimitShowPreviewInFullMode)) &&
    tweetContext.isOpen &&
    mode == "tweet";
  const textWithoutImages =
    mode == "tweet"
      ? textState?.text?.replace(/(?:\[img:)(.*?)(?=\])]/g, "").replace(/#>poll:.*?#/g, "")
      : textState?.text;

  let dragProps = {};
  if (mode == "tweet") dragProps = { ...getRootProps({ style }) };

  // const iconSize = isFullMode ? '1.6em' : '1.3em'
  // console.log(textStyle["body.medium.white"]);
  const iconSize = "1.3em";

  return (
    <Flex
      h={forceHeight}
      flexDir="column"
      alignItems="stretch"
      position="relative"
    >
      <AiGradientSvg />
      {isThreadReady && (
        <Flex
          position="fixed"
          right="400px" //transform="translateX(-30%)"
          top="0"
          w={showDesktopPreview ? "670px" : "460px"}
          h={"100%"}
          borderLeft={"solid 1px " + bgGray100_600}
          bg={bgWhite_gray800}
          overflow="hidden scroll"
          flexDir="column"
          justifyContent="space-between"
          display={"relative"}
        >
          <Flex
            position="relative"
            flexDir="column"
            justifyContent="space-between"
            h="100%"
          >
            <Box>
              <Thread
                maxW={showDesktopPreview ? "670px" : "400px"}
                threadTweets={textState?.threadTweets}
                showSeeMoreDivider={true}
                dividerCss={{
                  marginRight: showDesktopPreview ? "-55px" : "-60px",
                  width: `calc(100% + ${showDesktopPreview ? "55px" : "60px"})`,
                }}
                dividerAfterLineCount={showDesktopPreview ? 5 : 3}
                displayImageOptions={true}
                image={image}
                showGenerateImage
                showCanvaPDFNotice={showPDFNotice}
                disablePollActions={false}
              />
            </Box>

            <Flex position="absolute" top="20px" right="20px">
              <CopyToClipboard
                text={"https://taplio.com/public?id=" + tweetContext?.id}
                onCopy={() => {
                  toast.success("Public url copied to clipboard");
                }}
              >
                <IconButton
                  aria-label="GitHub"
                  icon={<FiShare2 fontSize="18px" />}
                  variant="light"
                  size="sm"
                />
              </CopyToClipboard>
              {!isFullMode && (
                <ButtonGroup ml={2} size="sm" isAttached variant="light">
                  <IconButton
                    variant={showDesktopPreview ? "lightSelected" : "light"}
                    aria-label="Desktop preview"
                    icon={<FaDesktop />}
                    onClick={(e) => setShowDesktopPreview(true)}
                  />
                  <IconButton
                    {...{
                      ml: "-1px",
                    }}
                    variant={!showDesktopPreview ? "lightSelected" : "light"}
                    aria-label="Mobile preview"
                    icon={<FaMobileAlt />}
                    onClick={(e) => setShowDesktopPreview(false)}
                  />
                </ButtonGroup>
              )}
            </Flex>
          </Flex>
        </Flex>
      )}
      {!disableHeader && (
        <>
          {isFullMode ? (
            <Box
              mb={4}
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Flex alignItems={"center"}>
                <Flex justifyContent="flex-start" alignItems="center" mr={3}>
                  <FiEdit3 size="1.2em" color="#272c38" />
                  <Text ml={2} fontSize={"md"} fontWeight={700}>
                    Content
                  </Text>
                </Flex>
                {renderNewDraftButton()}
              </Flex>
              {createDraft &&
                (isSaving ? (
                  <Box ml={1}>
                    <Spinner size="xs" color="gray.400" />
                  </Box>
                ) : (
                  <Text align="right" color="gray.400" fontSize="sm" as="i">
                    Saved as draft @{moment().format("HH:mm")}
                  </Text>
                ))}
            </Box>
          ) : (
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Text
                textStyle={textStyle["body.medium.light"]}
                textStyle={textStyle["body.bold.standard"]}
              >
                Your content
              </Text>
              {renderNewDraftButton()}
            </Box>
          )}
        </>
      )}
      <Box h={"85%"} position="relative">
        <Box flex={1} {...(isFullMode && { height: "100%" })}>
          {isFullMode ? (
            <Center w="100%" h="100%">
              <Box w="100%" h="100%" maxW="500px" position="relative">
                {renderTextArea()}
                {suggestionsUI}
              </Box>
            </Center>
          ) : (
            <>
              {renderTextArea()}
              {suggestionsUI}
            </>
          )}
        </Box>
      </Box>

      <Box display="flex" justifyContent="space-between" minHeight={10}>
        <Box display="flex" justifyContent="flex-end" pt={2}>
          {nbChar > 2500 && (
            <Text
              textStyle={textStyle["body.medium.light"]}
              align="right"
              color={nbChar > 2800 ? "red" : "gray.400"}
              fontWeight={nbChar > 2800 ? "bold" : "regular"}
              fontSize="sm"
              mr={5}
            >
              {nbChar} / 2800
            </Text>
          )}
          {createDraft &&
            !isFullMode &&
            (isSaving ? (
              <Box ml={0}>
                <Spinner size="xs" color="gray.400" />
              </Box>
            ) : (
              <Text
                textStyle={textStyle["body.medium.light"]}
                align="right"
                fontStyle={"italic"}
                textStyle={"body.medium.light"}
              >
                saved
              </Text>
            ))}
        </Box>
        {!isFullMode && renderEditOptions()}
      </Box>

      {isFullMode && (
        <Center>
          <Flex justifyContent="center" alignItems="center" flexDir="column">
            {isRichTextOpen && (
              <Flex mb={2} bg={bgWhite_gray800} rounded="xl" p={1} px={4}>
                {renderRichTextOptions({ mb: 0 })}
              </Flex>
            )}
            <Flex bg={bgWhite_gray800} rounded="xl" p={1} pb={2} px={4}>
              {renderEditOptions("center")}
            </Flex>
          </Flex>
        </Center>
      )}

      {!isFullMode && isRichTextOpen && renderRichTextOptions()}

      {!disableImage && textState?.files?.length > 0 && (
        <Box
          position="relative"
          // right="10px"
          // bottom="15px"
          // bg="red"
          mt={1}
          mb={4}
          display="flex"
          justifyContent="flex-end"
          overflow="visible"
          h="32px"
          // maxW="300px"
          // overflow="scroll"
        >
          {textState.files.map((x, index) => (
            <ImageThumbnail
              key={"ImageThumbnail-" + x}
              id={x}
              removeImage={(id) => {
                textState.text = textState.text.replace("[img:" + id + "]", "");
                // textState.threadTweets = [textState.text]
                // textState.files = extractImages(textState.text)
                // updateState(textState)
                editText(textState.text);
              }}
              onClick={imageEditor ? () => handleImageClick(x) : undefined}
            />
          ))}
        </Box>
      )}
      {!!tweetError?.text && (
        <Text
          mb={1}
          textStyle={textStyle["body.medium.light"]}
          color={
            tweetError?.type == "error"
              ? "red"
              : tweetError?.type == "warning"
                ? "orange.500"
                : "gray.500"
          }
          fontSize="sm"
        >
          <i>{tweetError?.text}</i>
        </Text>
      )}
      {mode == "tweet" &&
        (textState?.text?.includes("@") ||
          tweetContext.selectedCompany?.idShort ||
          textState?.text?.includes("img:doc-")) && (
          <Text
            textStyle={textStyle["body.medium.light"]}
            color="gray.500"
            mt={2}
            fontSize="xs"
          >
            <i>
              Posts using <b>mentions</b>, <b>company posting</b> or{" "}
              <b>posting a PDF</b>, will be published with the Taplio Chrome
              Extension. The process is slightly less reliable, make sure you
              have up-to-date Linkedin cookies by{" "}
              <Link href="https://linkedin.com/feed" isExternal>
                opening the Taplio Chrome Extension
              </Link>
            </i>
          </Text>
        )}
      {!!selectedTweet?.full_text && getSimilarityWarning()}
      <Modal
        isOpen={isOpenImageUpload}
        onClose={onCloseImageUpload}
        size={tabIndex === 0 ? "md" : "2xl"}
        scrollBehavior={tabIndex === 1 && medias.length > 0 && "inside"}
      >
        <ModalOverlay />
        <ModalContent>
          <Tabs
            onChange={(index) => {
              setTabIndex(index);
              if (index !== 1 || hasFetchedMedia) return;

              fetchData();
            }}
            overflowY={tabIndex === 1 && "scroll"}
          >
            <TabList>
              <Tab>Upload / Generate</Tab>
              <Tab>My Assets</Tab>
            </TabList>
            <TabPanels>
              <TabPanel>
                <ModalHeader>Add an image, video or document</ModalHeader>
                <ModalCloseButton />
                <ModalBody pb={6}>
                  <FilePond
                    className="upload-image-filepond"
                    ref={refPond}
                    dropOnElement={false}
                    dropValidation={mode == "tweet"}
                    oninit={() => handleInit()}
                    allowPaste={true}
                    allowImagePreview={false}
                    onaddfilestart={(item) => {
                      if (item.file.type.includes("application/pdf")) {
                        const reader = new FileReader();
                        reader.onload = (evt) => {
                          const pdfXMP = evt.target.result as string;
                          const canvaMatches = [
                            ...pdfXMP.matchAll(
                              /\/Creator \(Canva\)|(\/Producer \(Canva\))/gim
                            ),
                          ];
                          if (canvaMatches?.length > 0) {
                            textState.hasAttachedCanvaPDF = true;
                            setShowPDFNotice(true);
                          } else {
                            setShowPDFNotice(false);
                            textState.hasAttachedCanvaPDF = false;
                          }
                        };
                        reader.readAsText(item.file);
                      }
                    }}
                    beforeAddFile={async (item) => {
                      const validationResult = await validateFile(item.file);
                      if (!validationResult.isValid) {
                        toast.error(validationResult.message);
                        return false;
                      }

                      const { fileType } = validationResult;
                      const mediaTypes = getMediaTypesInText(textState.text);

                      if (isMediaTypeDisabled(mediaTypes, fileType)) {
                        const errorMessage = getMediaCompatibilityError(mediaTypes, fileType);
                        toast.error(errorMessage);
                        return false;
                      }

                      const isGifOrVideo = fileType === "gif" || fileType === "video";

                      if (isGifOrVideo) {
                        const existingGifOrVideoCount = refData.current.files.filter(
                          (link) => link.includes("gif-") || link.includes("vid-")
                        ).length;

                        const totalGifOrVideoCount = existingGifOrVideoCount + uploadingGifOrVideoCountRef.current;

                        if (totalGifOrVideoCount >= MAX_GIF_VIDEO_COUNT) {
                          if (!toastShownRef.current) {
                            toast.error(`Post with GIF or video can't have more than ${MAX_GIF_VIDEO_COUNT} media`);
                            toastShownRef.current = true;
                            setTimeout(() => (toastShownRef.current = false), 2000);
                          }
                          return false;
                        }

                        uploadingGifOrVideoCountRef.current++;
                      }

                      const totalMediaCount = refData.current.files.length + (isGifOrVideo ? 0 : 1);
                      if (totalMediaCount > MAX_MEDIA_COUNT) {
                        toast.error(`Maximum of ${MAX_MEDIA_COUNT} media files allowed`);
                        return false;
                      }

                      return true;
                    }}
                    onupdatefiles={async (filesUpdated) => {
                      if (filesUpdated.length === 0) {
                        return;
                      }

                      let uniqueLinks = new Set(refData.current.files);
                      let existingGifOrVideoCount = Array.from(uniqueLinks).filter(
                        (link) => link.includes("gif-") || link.includes("vid-")
                      ).length;

                      for (const x of filesUpdated) {
                        const isPdf = x.file.type.includes("application/pdf");
                        const isGif = x.file.type === "image/gif";
                        const isVideo = x.file.type.includes("video");

                        if ((isGif || isVideo) && existingGifOrVideoCount >= 1) {
                          if (!toastShownRef.current) {
                            toastShownRef.current = true;
                          }
                          continue;
                        }

                        if (!x.getMetadata("fileName")) {
                          let id = "";
                          if (isVideo) id += "vid-";
                          if (isGif) id += "gif-";
                          if (isPdf) id += "doc-";
                          id += shortid.generate().replace("-", "_");

                          let fileName = id;
                          let link = `https://ez4cast.s3.eu-west-1.amazonaws.com/userUpload/${fileName}`;

                          x.setMetadata("id", id);
                          x.setMetadata("fileName", fileName);
                          x.setMetadata("link", link);
                        }

                        const link = x.getMetadata("link");

                        if (!uniqueLinks.has(link)) {
                          uniqueLinks.add(link);
                          if (isGif || isVideo) existingGifOrVideoCount++;
                        }
                      }

                      refData.current.files = Array.from(uniqueLinks);
                      uploadingGifOrVideoCountRef.current = 0;

                    }}
                    onprocessfile={async (error, file) => {
                      if (!file || !file.file) {
                        return;
                      }

                      if (uploadingFiles.includes(file.file.name)) {
                        uploadingFiles.splice(uploadingFiles.indexOf(file.file.name), 1);
                      }

                      if (error) {
                        toast.error("An error occurred while uploading your content");
                        return;
                      }

                      const newLink = file.getMetadata("link");
                      const fileName = file.getMetadata("fileName");
                      const fileId = file.getMetadata("id");

                      if (processedFiles.has(fileName) || textState.text.includes(`[img:${fileName}]`)) {
                        return;
                      }

                      processedFiles.add(fileName);

                      if (newLink && newLink.startsWith("https://")) {
                        try {
                          const currentText = textState.text;

                          const updatedText = `${currentText} [img:${fileName}]`.trim();


                          await editText(updatedText);

                          setTextState((prev) => {
                            if (prev.text.includes(`[img:${fileName}]`)) {
                              return prev;
                            }

                            const baseText = prev.text === currentText ? currentText : prev.text;
                            const newText = `${baseText} [img:${fileName}]`.trim();

                            return {
                              ...prev,
                              text: newText,
                              files: prev.files.includes(fileName) ? prev.files : [...prev.files, fileName]
                            };
                          });

                          if (fileName.includes("doc-")) {
                            onOpenDocument();
                          }
                        } catch (updateError) {
                          captureException(updateError, {
                            tags: {
                              location: "onprocessfile",
                              action: "state_update"
                            }
                          });
                          processedFiles.delete(fileName);
                        }
                      } else {
                        captureMessage("Invalid link skipped", {
                          level: "warning",
                          tags: {
                            location: "onprocessfile",
                            link: newLink
                          }
                        });
                        processedFiles.delete(fileName);
                      }

                      const pendingFiles = refPond.current?.getFiles()?.filter(f => f.status !== 5);
                      if (!pendingFiles || pendingFiles.length === 0) {
                        processedFiles.clear();
                        onCloseImageUpload();
                      }
                    }}
                    allowMultiple={true}
                    maxFiles={999}
                    name="files"
                    labelIdle={filePondLable}
                    credits={{ label: "", url: "" }}
                    server={{
                      process: async (
                        fieldName,
                        file,
                        metadata,
                        load,
                        error,
                        progress,
                        abort
                      ) => {
                        if (!tweetContext.isOpen) {
                          captureMessage("Tweet context closed, skipping upload", {
                            level: "warning",
                            tags: {
                              location: "server_process",
                              fileName: file.name
                            }
                          });
                          return { abort: () => { } };
                        }

                        const validationResult = await validateFile(file);
                        if (!validationResult.isValid) {
                          captureMessage("File validation failed", {
                            level: "error",
                            tags: {
                              location: "server_process",
                              message: validationResult.message
                            }
                          });
                          error(validationResult.message);
                          return { abort: () => { } };
                        }

                        const { fileType } = validationResult;
                        const isGif = fileType === "gif";

                        if (fileType !== "gif") {
                          setIsSavingImage(true);
                        } else {
                          setIsSavingGif(true);
                        }

                        const fileName = metadata.fileName;
                        const fileId = metadata.id || fileName;

                        try {
                          const ab = await file.arrayBuffer();
                          const buffer = Buffer.from(ab);
                          const params = {
                            Bucket: BUCKET_NAME,
                            Key: "userUpload/" + fileName,
                            Body: buffer,
                            ACL: "public-read",
                          };

                          const url = await uploadOnS3(params);
                          metadata.link = url;

                          load(url);

                          if (fileType !== "pdf") {
                            const response = await postMedia(session, {
                              url,
                              type: file.type,
                              fileName,
                              size: file.size,
                              id: fileId,
                            });

                            if (response?.success === 0) {
                              captureMessage("Backend rejected media", {
                                level: "warning",
                                tags: {
                                  location: "server_process",
                                  error: response.error
                                }
                              });
                              error("Media processing failed: " + (response.error || "Unknown error"));
                              return;
                            }

                            if (fileType === "video") {
                              await createThumbnail(session, {
                                id: fileId,
                                isInfluentLeader: true,
                              });
                            }
                          }

                        } catch (e) {
                          error("Upload failed: " + (e.message || "Unknown error"));
                        } finally {
                          setIsSavingImage(false);
                          setIsSavingGif(false);
                          toastShownRef.current = false;
                        }

                        return {
                          abort: () => {
                            setIsSavingImage(false);
                            setIsSavingGif(false);
                            toastShownRef.current = false;
                          },
                        };
                      },
                    }}
                  />
                  <Text textAlign="center" mb={4}>
                    or
                  </Text>
                  <Text textAlign="center" mb={4} fontWeight="bold">
                    Generate an image with AI
                  </Text>
                  <GenerateImage
                    content={textState?.text}
                    onImageGenerated={(fileName) => {
                      textState.text += `[img:${fileName}]`;
                      editText(textState.text);
                      onCloseImageUpload();
                    }}
                  />
                </ModalBody>
              </TabPanel>
              <TabPanel>
                <ModalHeader>Select an asset from your library</ModalHeader>
                <ModalCloseButton />
                <ModalBody pb={6}>
                  {!hasFetchedMedia && (
                    <Box
                      width={"100%"}
                      mt={6}
                      display={"flex"}
                      alignItems={"center"}
                      justifyContent={"center"}
                    >
                      <Loader
                        color={
                          colorMode === "dark"
                            ? hslToHsla(colors.primary.lightMode[100], 1)
                            : hslToHsla(colors.primary.lightMode[400], 1)
                        }
                      />
                    </Box>
                  )}
                  {hasFetchedMedia && !!medias.length && (
                    <MediaMasonry
                      colorMode={colorMode}
                      medias={medias}
                      tweetContext={tweetContext}
                      modalMode
                      setSelectedMedias={setSelectedMedias}
                      selectedMedias={selectedMedias}
                    />
                  )}
                </ModalBody>
              </TabPanel>
            </TabPanels>
          </Tabs>
          {tabIndex === 1 && (
            <ModalFooter style={{ padding: "10px 0" }}>
              <Button
                onClick={handleUseMediaSelection}
                style={{
                  ...(selectedMedias.length > 0 && {
                    color: colors.success.lightMode[400],
                    border: `2px solid ${colors.success.lightMode[400]}`,
                  }),
                }}
              >
                Use selection ({selectedMedias.length})
              </Button>
            </ModalFooter>
          )}
        </ModalContent>
      </Modal>

      <ImageEditPopup
        isOpen={isOpenImageEdit}
        onClose={onCloseImageEdit}
        imageId={selectedImageId}
        onSave={onCloseImageEdit}
        onSave={(newMedia) => {
          editText(textState.text.replace(selectedImageId, newMedia.id));
          onCloseImageEdit();
        }}
      />
      <Modal
        isOpen={isOpenDocument}
        onClose={onCloseDocument}
        closeOnOverlayClick={false}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            {/* <ModalInfoIcon /> */}
            {"Name your document"}
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <FormControl
              as="form"
              onSubmit={(e) => {
                e.preventDefault();
                saveDocumentName();
              }}
            >
              <FormLabel>Document Title:</FormLabel>
              <Input
                placeholder="My amazing carousel"
                onChange={(e) => setDocumentName(e.target.value)}
              />
            </FormControl>
          </ModalBody>
          <ModalFooter>
            <Button
              onClick={saveDocumentName}
              // colorScheme="blue"
              // bg="blue.700"
              // color="white"
              // _hover={{ bg: "blue.600" }}
              variant={variant.Button.primary}
            >
              Save
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <PollModal
        isOpen={isPollOpen}
        onClose={onClosePoll}
        pollQuestion={pollQuestion}
        setPollQuestion={setPollQuestion}
        pollOptions={pollOptions}
        setPollOptions={setPollOptions}
        pollDuration={pollDuration}
        setPollDuration={setPollDuration}
        onSave={handleSavePoll}
      />
    </Flex>
  );
});
